module.exports = __webpack_public_path__ + "static/media/icon_scan_camera.7bd5a243.svg";